module.exports = __webpack_public_path__ + "img/diamond.f9cf7df2.svg";